module.exports = __webpack_public_path__ + "fonts/fa-regular-400.cb5f6f8.woff2";